<template>
  <div class="marquee-container">
    <Toast ref="toast" class="msgToast"/>
  </div>
</template>

<script>
let timer
import Toast from '@src/components/toast/toast.vue'
export default {
  name: "bubbleMsg",  
  components:{
    Toast
  },
  props: {
    msgs: {
      type: Array,
      },
  },
  beforeDestroy(){
    clearInterval()
  },
  mounted() {
    console.log(this.$refs.toast)
    let i = 0
     this.$refs.toast.showToast(this.msgs[i])
      timer=setInterval(() => {
      this.msg = this.msgs[i++]
      this.$refs.toast && this.$refs.toast.showToast(this.msgs[i])
      if (i === this.msgs.length) {
        i = 0
      }
    }, 3200)
  },
};
</script>

<style lang="stylus" scoped>
.marquee-container {
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  width: 100%;
  text-align: center;
  justify-content center;
  height 1.59rem
  align-items: center;
  z-index:1
}

</style>



// WEBPACK FOOTER //
// src/components/bubbleMsg/index.vue